import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconProps"];
import React from "react";
import Link from "../Link";
import EllipsisIcon from "../MultiToneIcons/EllipsisIcon";
export default /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconProps = _ref.iconProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Link, _extends({
    hoverTextDecoration: "none",
    as: "button",
    role: "button",
    ref: ref
  }, props), /*#__PURE__*/React.createElement(EllipsisIcon, iconProps));
});